import React from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

const THEME_ACTIVE = {
  blue: "text-blue-600 bg-blue-50",
  green: "text-green-600 bg-green-50",
  indigo: "text-indigo-600 bg-indigo-50",
  purple: "text-purple-600 bg-purple-50",
};

const SortableTh = ({
  columnKey,
  label,
  activeKey,
  activeDirection,
  onSortSet,
  onSortLabelClick,
  className = "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hover:bg-gray-100",
  theme = "blue",
}) => {
  const ascOn = activeKey === columnKey && activeDirection === "asc";
  const descOn = activeKey === columnKey && activeDirection === "desc";
  const activeClass = THEME_ACTIVE[theme] || THEME_ACTIVE.blue;

  const chevronBtnClass = (active) =>
    `p-0.5 rounded shrink-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 ${
      active ? activeClass : "text-gray-400 hover:text-gray-600"
    }`;

  return (
    <th className={className}>
      <div className="inline-flex items-center gap-1.5 max-w-full">
        <button
          type="button"
          onClick={() => onSortLabelClick(columnKey)}
          className="text-left min-w-0 hover:text-gray-800"
        >
          <span className="break-words">{label}</span>
        </button>
        <span className="inline-flex flex-row items-center shrink-0 gap-0.5">
          <button
            type="button"
            aria-label="Sort ascending"
            aria-pressed={ascOn}
            className={chevronBtnClass(ascOn)}
            onClick={(e) => {
              e.stopPropagation();
              onSortSet(columnKey, "asc");
            }}
          >
            <FaChevronUp className="w-3 h-3" aria-hidden />
          </button>
          <button
            type="button"
            aria-label="Sort descending"
            aria-pressed={descOn}
            className={chevronBtnClass(descOn)}
            onClick={(e) => {
              e.stopPropagation();
              onSortSet(columnKey, "desc");
            }}
          >
            <FaChevronDown className="w-3 h-3" aria-hidden />
          </button>
        </span>
      </div>
    </th>
  );
};

export default SortableTh;
